const watchlistFields = {
    ip: ['source_ip', 'host_ip', 'destination_ip', 'network_forwarded_ip', 'source_nat_ip', 'destination_nat_ip'],
    user: ['source_user_name', 'user_name', 'destination_user_name', 'target_user_name'],
    hash: ['hash_md5', 'hash_sha1', 'hash_sha256', 'hash_sha512', 'hash_imphash']
};
export default watchlistFields;
